import React, { ComponentType, createElement, FunctionComponent } from 'react';
import { shallowEqual } from 'react-redux';
import { Box } from '@mui/material';

import { hasTrussDesignPermission } from '@paragon/login-tools';
import { WalkthroughBlurbAnchor } from '@paragon/tour-guide';

import { SelectedItemIdentifier } from '../../../../../library/selection/types';
import { RootState } from '../../../../../store';
import {
  getSelectedItemEntries,
  getSingleSelectedItemEntryOrNull,
} from '../../../../../store/selectors/getSelectedItemSelector';
import { inViewOnlyMode } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { CollapseAllButton } from './CollapseAllButton';
import { ButtonBarButtonProps, ButtonBarContext } from './common';
import { DeleteAllButton } from './DeleteAllButton';
import { DeleteSelectedButton } from './DeleteSelectedButton';
import { FocusSelectedButton } from './FocusSelectedButton';

const GENERATED_BUTTONS: ComponentType<ButtonBarButtonProps>[] = [FocusSelectedButton, CollapseAllButton];

type StateProps = ReturnType<typeof mapStateToProps>;
type PassedProps = Partial<StateProps> & {
  panelContext: ButtonBarContext;
  onFocusItemRequested: (item: SelectedItemIdentifier) => void;
};

const HeaderButtonBar: FunctionComponent<PassedProps> = (props) => {
  const dispatch = useAppDispatch();
  const stateProps = useAppSelector(mapStateToProps, shallowEqual);

  const { onFocusItemRequested, ...passedInProps } = props;

  const buttonProps: ButtonBarButtonProps = {
    ...stateProps,
    ...passedInProps, // passed in props allow overriding state props; the levels panel depends on this behavior
    focusGridOnRow: onFocusItemRequested,
    dispatch,
  };

  return (
    <WalkthroughBlurbAnchor id="navigation-panel-button-bar" blurbPlacement="left">
      <Box sx={{ p: 1, display: 'flex', justifyContent: 'start' }}>
        {GENERATED_BUTTONS.map((buttonComponent, i) => createElement(buttonComponent, { ...buttonProps, key: i }))}
        <span style={{ flexGrow: 1 }} />

        <DeleteSelectedButton />
        <DeleteAllButton />
      </Box>
    </WalkthroughBlurbAnchor>
  );
};

const mapStateToProps = (state: RootState) => ({
  componentIsViewOnly: inViewOnlyMode(state),
  hasTrussDesignPermission: hasTrussDesignPermission(state),
  activeEntry: getSingleSelectedItemEntryOrNull(state),
  activeEntries: getSelectedItemEntries(state),
});

export default HeaderButtonBar;
